import * as types from './renameRulesTypes';

export function transformRuleToRequestData(rule) {
  return {
    id: rule.id,
    clientId: rule.clientId,
    isDeleted: rule.isDeleted,
    renamePayeeFrom: rule.renamePayeeFrom,
    renamePayeeTo: rule.renamePayeeTo,
    isDoNotRename: rule.isDoNotRename,
    matchCriteria: rule.matchCriteria,
    applyToExistingTxns: rule.applyToExistingTxns,
  };
}

export function transformRulesToRequestData(rules) {
  return {
    resources: rules.map(transformRuleToRequestData),
  };
}

export function transformResponseToRules(response) {
  return response.data.resources.map((data) =>
    types.mkRenameRule({
      id: data.id,
      clientId: data.clientId,
      isDeleted: data.isDeleted,
      renamePayeeFrom: data.renamePayeeFrom,
      renamePayeeTo: data.renamePayeeTo,
      isDoNotRename: data.isDoNotRename,
      matchCriteria: data.matchCriteria,
      applyToExistingTxns: data.applyToExistingTxns,
    }),
  );
}
